<template>
  <v-dialog
      ref="dialog"
      v-model="open"
      :return-value.sync="time_table"
      persistent
      width="720px"
  >
    <v-card>
      <v-card-title>เลือกช่วงเวลา</v-card-title>
      <table style="text-align: center;width: 100%" class="time-table">
        <tr>
          <td>วัน</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>
        <tr>
          <td>อาทิตย์</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>
        <tr>
          <td>จันทร์</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>
        <tr>
          <td>อังคาร</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>
        <tr>
          <td>พุธ</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>
        <tr>
          <td>พฤหัส</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>
        <tr>
          <td>ศุกร์</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>
        <tr>
          <td>เสาร์</td>
          <td>06</td>
          <td>07</td>
          <td>08</td>
          <td>09</td>
          <td>10</td>
          <td>11</td>
          <td style="background: #CCCCCC">12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
        </tr>


      </table>
      <v-card-actions>

        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="open = false"
        >
          Cancel
        </v-btn>
        <v-btn

            color="primary"

            @click="onApply(time_table);open=false"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.time-table{
  td{
    height: 50px;
  }
}
</style>
<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class TimeTablePicker extends Vue {

  open: boolean = false
  time_table = {}

  onApply: Function = () => {
  }

  created() {
    this.$root.$on('openTimeTablePicker', this.onOpen)
  }

  onOpen({time_table, onApply}) {
    if (this.open) return
    console.log('Emited', {time_table})
    this.time_table = time_table

    this.open = true

    this.onApply = onApply
  }

};

</script>
